import moment from 'moment';
import {Constants} from "./Constants";

export let DateUtility = {
    fpDateToMoment: function (inputDate?: string) {
        if (inputDate) {
            return moment(inputDate, 'YYYY-MM-DDTHH:mm:ss.SSS');
        } else {
            return null;
        }
    },

    fpInvoiceDateToDisplayDate: function (fpInvoiceDateString?: string) {
        if (fpInvoiceDateString) {
            return DateUtility.momentToDisplayDate(
                DateUtility.fpInvoiceDateToMoment(fpInvoiceDateString) as moment.Moment
            );
        } else {
            return null;
        }
    },

    fpInvoiceDateToMoment: function (fpInvoiceDateString?: string) {
        if (fpInvoiceDateString) {
            return moment(fpInvoiceDateString.split('+')[0], 'YYYY-MM-DDTHH:mm:ss');
        } else {
            return null;
        }
    },

    fpInvoiceDateToJsDate: function (fpInvoiceDateString?: string) {
        if (fpInvoiceDateString) {
            return DateUtility.fpInvoiceDateToMoment(fpInvoiceDateString)?.toDate();
        } else {
            return null;
        }
    },

    momentToLocalMoment: function (momentIn: moment.Moment) {
        return momentIn.local();
    },

    momentToDisplayDate: function (momentIn: moment.Moment) {
        return momentIn.format('MM/DD/YYYY');
    },

    fpDateToLocalTextDate: function (inputDate?: string) {
        if (inputDate) {
            return DateUtility.momentToDisplayDate(DateUtility.fpDateToMoment(inputDate) as moment.Moment);
        } else {
            return null;
        }
    },

    qboTxnDateToDateDisplay: function (qboTxnDate: string) {
        return DateUtility.momentToDisplayDate(moment(qboTxnDate, 'YYYY-MM-DD'))
    },

    stripeTimestampToDateDisplay: function (stripeTimestamp: number) {
        return DateUtility.momentToDisplayDate(
            DateUtility.stripeTimestampToMoment(stripeTimestamp)
        )
    },

    stripeTimestampToMoment: function (stripeTimestamp: number) {
        return moment.unix(stripeTimestamp)
    },

    dbDateToTimestamp: function (inputDate: string) {
        return DateUtility.dbDateToMoment(inputDate)?.unix()
    },

    dbDateToMoment: function (inputDate?: string) {
        if (inputDate) {
            return moment.utc(inputDate.replace('Z', ''), 'YYYY-MM-DDTHH:mm:ss.SSS');
        } else {
            return null;
        }
    },

    dbDateToLocalMoment: function (inputDate?: string) {
        if (inputDate) {
            return this.dbDateToMoment(inputDate)?.local();
        } else {
            return null;
        }
    },

    dbDateToLocalDisplayDate: function (inputDate?: string) {
        if (inputDate) {
            return DateUtility.momentToDisplayDate(DateUtility.dbDateToLocalMoment(inputDate) as moment.Moment)
        } else {
            return null;
        }
    },

    currentJsDate: function () {
        return moment().toDate()
    },

    jsDateToUnixTimestamp: function (jsDate: Date) {
        return moment(jsDate).unix()
    },

    dateFilterStringToJsDate: function (dateFilterString?: string) {
        if (dateFilterString) {
            return DateUtility.dateFilterStringToMoment(dateFilterString)?.toDate()
        } else {
            return null;
        }
    },

    dateFilterStringToMoment: function (dateFilterString?: string) {
        if (dateFilterString) {
            return moment(dateFilterString, Constants.dateFilterStringFormat)
        } else {
            return null;
        }
    },

    jsDateToFilterDateDisplay: function (jsDate?: Date) {
        if (jsDate) {
            return moment(jsDate).format('MM/DD/YYYY')
        } else {
            return '';
        }
    },

    jsDateToFilterString: function (jsDate?: Date) {
        if (jsDate) {
            return moment(jsDate).format(Constants.dateFilterStringFormat)
        } else {
            return '';
        }
    },

    jsDateToMoment: function (jsDate: Date) {
        return moment(jsDate)
    },
}
